import * as actionTypes from './actionTypes';

const initialState = {
  ids: [],
  isLoading: false,
  editingDocumentDashboardIdsWithFavorite: {
    isLoading: false,
    ids: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ids: action.ids,
      };
    case actionTypes.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE:
      return {
        ...state,
        editingDocumentDashboardIdsWithFavorite: {
          ...state.editingDocumentDashboardIdsWithFavorite,
          isLoading: true,
        },
      };
    case actionTypes.FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_SUCCESS:
      return {
        ...state,
        editingDocumentDashboardIdsWithFavorite: {
          isLoading: false,
          ids: action.ids,
        },
      };
    case actionTypes.REMOVE_FAVORITE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter(id => id !== action.id),
      };
    default:
      return state;
  }
};
